import { FormatFunction } from 'i18next';
import { format as formatDate } from 'date-fns';

/**
 * Format functions for string interpolation, use to add additional formatting options to i18next
 * see https://www.i18next.com/translation-function/formatting
 */
export const format: FormatFunction = (value, format /*, language*/) => {
  if (format === 'uppercase') return value.toUpperCase();
  if (value instanceof Date && format) return formatDate(value, format);
  return value;
};

export default format;
